var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityFillSidebar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "49 638 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 649.333a2.833 2.833 0 1 1 0-5.666 2.833 2.833 0 0 1 0 5.666Zm0-4.25a1.417 1.417 0 1 0 0 2.834 1.417 1.417 0 0 0 0-2.834Zm4.25 9.209a4.25 4.25 0 1 0-8.5 0 .708.708 0 0 0 1.417 0 2.833 2.833 0 1 1 5.666 0 .708.708 0 0 0 1.417 0Zm0-10.625a2.833 2.833 0 1 1 0-5.667 2.833 2.833 0 0 1 0 5.667Zm0-4.25a1.417 1.417 0 1 0 0 2.833 1.417 1.417 0 0 0 0-2.833Zm4.25 9.208a4.254 4.254 0 0 0-4.25-4.25.708.708 0 1 0 0 1.417 2.833 2.833 0 0 1 2.833 2.833.708.708 0 0 0 1.417 0Zm-12.75-4.958a2.833 2.833 0 1 1 0-5.667 2.833 2.833 0 0 1 0 5.667Zm0-4.25a1.417 1.417 0 1 0 0 2.833 1.417 1.417 0 0 0 0-2.833Zm-2.833 9.208a2.833 2.833 0 0 1 2.833-2.833.708.708 0 0 0 0-1.417 4.254 4.254 0 0 0-4.25 4.25.708.708 0 0 0 1.417 0Z",
    fill: "#fe6036",
    fillRule: "evenodd",
    "data-name": "users-alt"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityFillSidebar);
export default __webpack_public_path__ + "static/media/communityFillSidebar.80ae73d4cfeae1772183c6de6a510ba2.svg";
export { ForwardRef as ReactComponent };